
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M437.02 74.98C388.667 26.629 324.38 0 256 0S123.333 26.629 74.98 74.98 0 187.62 0 256s26.629 132.667 74.98 181.02S187.62 512 256 512s132.667-26.629 181.02-74.98S512 324.38 512 256s-26.629-132.667-74.98-181.02zm-21.214 340.826C373.12 458.492 316.367 482 256 482s-117.12-23.508-159.806-66.194S30 316.367 30 256 53.508 138.88 96.194 96.194 195.633 30 256 30s117.12 23.508 159.806 66.194S482 195.633 482 256s-23.508 117.12-66.194 159.806zM175.607 156.268c12.992 0 23.562 10.57 23.562 23.562h30c0-29.534-24.028-53.562-53.562-53.562s-53.563 24.028-53.563 53.562h30c0-12.992 10.57-23.562 23.563-23.562zm160.786 0c12.993 0 23.563 10.57 23.563 23.562h30c0-29.534-24.028-53.562-53.563-53.562s-53.562 24.028-53.562 53.562h30c0-12.992 10.57-23.562 23.562-23.562zM100.704 274.01c0 85.631 69.666 155.296 155.296 155.296s155.296-69.665 155.296-155.296V241H100.704zm30-3.01h250.592v3.01c0 69.088-56.208 125.296-125.296 125.296S130.704 343.098 130.704 274.01z"}})])
          )
        }
      }
    